export default "__VITE_ASSET__CtS6LTlJ__"